export var geonamesApiKey = 'pavel.vlach';
export var geonamesApiUrl = 'https://secure.geonames.org/searchJSON';